import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BusinessPanel } from "@/components/layout/BusinessPanel";

export function Header() {
  const [isBusinessPanelOpen, setIsBusinessPanelOpen] = useState(false);

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-b border-border">
        <div className="container mx-auto px-6 lg:px-8 h-20">
          {/* 3-Column Grid Layout - Same for Mobile, Tablet, and Desktop */}
          <div className="grid grid-cols-[auto_1fr_auto] items-center h-full">
            
            {/* Left Section: Hamburger Menu Button (ALL DEVICES) */}
            <button
              onClick={() => setIsBusinessPanelOpen(true)}
              className="text-foreground p-2 hover:bg-secondary rounded-lg transition-colors"
              aria-label="Open navigation menu"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>

            {/* Center Section: Brand */}
            <Link to="/" className="flex items-center justify-center">
              <span className="text-2xl font-serif font-bold text-gradient-gold">
                VIATRA
              </span>
            </Link>

            {/* Right Section: CTA Button (visible on md: and lg:) */}
            <div className="flex items-center gap-4">
              <Link to="/contact">
                <Button variant="navGold">
                  Partner With Us
                </Button>
              </Link>
            </div>

          </div>
        </div>
      </header>

      {/* Business Navigation Panel - Slides from LEFT */}
      <BusinessPanel
        isOpen={isBusinessPanelOpen}
        onClose={() => setIsBusinessPanelOpen(false)}
      />
    </>
  );
}
